import { formatTimeString } from 'modules/application/detail/attendance/AttendanceUtils';
export class DashboardTeam {
    static $inject = ['averageAttendanceTime', 'averageCollapsedAttendanceTime', 'averageCollapsedResponseTime', 'averageCollapsedWaitTime', 'averageResponseTime', 'averageWaitTime', 'closedTickets', 'name', 'openedTickets', 'ticketsCount', 'waitingTickets'];
    constructor(averageAttendanceTime, averageCollapsedAttendanceTime, averageCollapsedResponseTime, averageCollapsedWaitTime, averageResponseTime, averageWaitTime, closedTickets, name, openedTickets, ticketsCount, waitingTickets) {
        this.averageAttendanceTime = averageAttendanceTime;
        this.averageCollapsedAttendanceTime = averageCollapsedAttendanceTime;
        this.averageCollapsedResponseTime = averageCollapsedResponseTime;
        this.averageCollapsedWaitTime = averageCollapsedWaitTime;
        this.averageResponseTime = averageResponseTime;
        this.averageWaitTime = averageWaitTime;
        this.closedTickets = closedTickets;
        this.name = name;
        this.openedTickets = openedTickets;
        this.ticketsCount = ticketsCount;
        this.waitingTickets = waitingTickets;
    }
    static fromObject(obj) {
        const averageAttendanceTime = formatTimeString(obj[DashboardTeam.AVERAGE_ATTENDANCE_TIME]);
        const averageCollapsedAttendanceTime = formatTimeString(obj[DashboardTeam.AVERAGE_ATTENDANCE_TIME], true);
        const averageCollapsedResponseTime = formatTimeString(obj[DashboardTeam.AVERAGE_RESPONSE_TIME], true);
        const averageCollapsedWaitTime = formatTimeString(obj[DashboardTeam.AVERAGE_WAIT_TIME], true);
        const averageResponseTime = formatTimeString(obj[DashboardTeam.AVERAGE_RESPONSE_TIME]);
        const averageWaitTime = formatTimeString(obj[DashboardTeam.AVERAGE_WAIT_TIME]);
        const closedTickets = obj[DashboardTeam.CLOSED_TICKETS];
        const name = obj[DashboardTeam.NAME];
        const openedTickets = obj[DashboardTeam.OPENED_TICKETS];
        const ticketsCount = obj[DashboardTeam.TICKETS_COUNT];
        const waitingTickets = obj[DashboardTeam.WAITING_TICKETS];
        return new DashboardTeam(averageAttendanceTime, averageCollapsedAttendanceTime, averageCollapsedResponseTime, averageCollapsedWaitTime, averageResponseTime, averageWaitTime, closedTickets, name, openedTickets, ticketsCount, waitingTickets);
    }
    static fromList(objList) {
        const dashboardTeamList = [];
        for (const obj of objList) {
            dashboardTeamList.push(DashboardTeam.fromObject(obj));
        }
        return dashboardTeamList;
    }
}
DashboardTeam.AVERAGE_ATTENDANCE_TIME = 'averageAttendanceTime';
DashboardTeam.AVERAGE_RESPONSE_TIME = 'averageResponseTime';
DashboardTeam.AVERAGE_WAIT_TIME = 'averageWaitTime';
DashboardTeam.CLOSED_TICKETS = 'closedTickets';
DashboardTeam.NAME = 'name';
DashboardTeam.OPENED_TICKETS = 'openedTickets';
DashboardTeam.TICKETS_COUNT = 'ticketsCount';
DashboardTeam.WAITING_TICKETS = 'waitingTickets';
DashboardTeam.$inject = ['averageAttendanceTime', 'averageCollapsedAttendanceTime', 'averageCollapsedResponseTime', 'averageCollapsedWaitTime', 'averageResponseTime', 'averageWaitTime', 'closedTickets', 'name', 'openedTickets', 'ticketsCount', 'waitingTickets'];
